// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setCustomPDFReportsListStore = createAction('[Custom PDF Report List Page] Set Custom PDF Reports List Store', props());
export const setCustomPDFReports = createAction('[Custom PDF Report List Page] Set Custom PDF Report', props());
export const deleteCustomPDFReport = createAction('[Custom PDF Report List Page] Delete Custom PDF Report', props());
export const updateCustomPDFReportWizardStep = createAction('[Custom PDF Report List Page] Update Custom PDF Report Wizard Steps', props());
